'use es6';

import ReferenceRecord from 'reference-resolvers/schema/ReferenceRecord';
import I18n from 'I18n';
import { fromJS, List } from 'immutable';
import indexBy from 'transmute/indexBy';
import get from 'transmute/get';
const formatWebinarTimes = (times = []) => times.map(get('startTime')).sort().map(timestamp => I18n.moment.portalTz(timestamp).format('lll')).join('; ');
const formatWebinarRecord = webinar => new ReferenceRecord({
  id: webinar.webinarKey,
  label: webinar.subject,
  description: formatWebinarTimes(webinar.times),
  referencedObject: fromJS(webinar)
});
const formatWebinars = webinarResponse => {
  const future = indexBy(get('id'), List(webinarResponse.future).map(formatWebinarRecord));
  const past = indexBy(get('id'), List(webinarResponse.past).map(formatWebinarRecord));
  return future.merge(past);
};
export default formatWebinars;